import axios, { AxiosResponse } from 'axios';

export const filterDictionary = (): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/filter-dictionary', {}, {
        params: {
            dictionaryCode: 'tax_classification',
            size: 1000
        },
    });
};

export const calculatePenalty = (data: any): Promise<AxiosResponse> => {
    return axios.post('/services/isnaportal/open-api/calculator/calculate-penalty', data);
};

export const getCurrentTime = (): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/admin/current-time');
};
